import React, { useState } from "react";
import { IoMdPlay } from "react-icons/io";
import { deleteTutorial, updateTutorial } from "../../services/tutorials";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";
import { MdOutlineDeleteOutline } from "react-icons/md";

const categories = {
  flowering: "Florecimiento",
  growth: "Crecimiento",
  resting: "Descanso",
  care: "Cuidado",
  feeding: "Alimentación",
  any: "Cualquiera",
};

const TutorialCard = ({
  tutorial,
  index,
  updateTutorialStatus,
  removeFromParent,
}) => {
  const [updating, setUpdating] = useState(false);

  const onClickCheck = (e) => {
    //actualizar en el backend
    const updateStatus = async () => {
      setUpdating(true);
      const newStatus = e.target.checked ? "visible" : "hidden";
      try {
        IS_LOCAL_ENV && console.log(tutorial.id);
        const { message } = await updateTutorial(tutorial.id, newStatus);
        IS_LOCAL_ENV && console.log(message);
        updateTutorialStatus(index, newStatus);
        setUpdating(false);
        Notification({
          title: "Operación completada",
          text: `Se actualizó el estado del tutorial`,
          type: "Success",
        });
      } catch (err) {
        setUpdating(false);
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    updateStatus();
  };

  const handleDeleteVideo = async () => {
    try {
      const { message } = await deleteTutorial(tutorial.id);
      Notification({
        title: "Operación completada",
        text: `Se eliminó el video del tutorial`,
        type: "Success",
      });
      removeFromParent(tutorial.id);
    } catch (err) {
      IS_LOCAL_ENV && console.error(err);
      Notification({
        title: "Error...",
        text: `Algo salió mal...`,
        type: "Error",
      });
    }
  };

  return (
    <>
      <div className="flex w-full md:m-2 m-1 flex-col ">
        <div className="bg-light-purple px-4 py-2 rounded-t-xl w-fit">
          <span className="font-bold font-poppins text-sm text-dark-purple w-fit">
            {categories[tutorial.category]}
          </span>
        </div>
        <div className=" max-w-[400px] w-full h-full flex flex-col relative bg-white rounded-xl rounded-tl-none shadow-md  relative">
          {updating && (
            <div className="absolute top-0 left-0 right-0 bottom-0 flex flex-col justify-center items-center z-20 bg-black bg-opacity-75 rounded-xl text-white font-bold text-lg font-poppins">
              <span>Actualizando...</span>
            </div>
          )}
          {/* <img src={props.bg} className="h-[220px] rounded-t-xl" /> */}
          <iframe
            className="w-full"
            style={{
              borderTopRightRadius: "15px",
              //width: "400px",
              // maxWidth: "400px",
              height: "200px",
              //aspectRatio: "3/1.8",

              margin: "0px !important",
            }}
            src={tutorial.url}
            frameBorder="0"
            allowFullScreen
            ng-show="showvideo"
          ></iframe>

          <div className="flex flex-row items-start  px-4 gap-x-2 py-4">
            <input
              type="checkbox"
              //defaultChecked={false}
              onChange={onClickCheck}
              className={`m-0 rounded-[2px] ${
                updating && "checked:bg-default-gray cursor-not-allowed"
              } checked:bg-accent-green focus:ring-transparent mt-1`}
              value={tutorial.status == "visible"}
              disabled={updating}
            />
            <div className=" relative flex font-poppins flex-col  gap-y-2 w-full">
              <div className="flex flex-row w-full justify-between ">
                <span className="font-bold text-base text-dark-green text-wrap">
                  {tutorial.title}
                </span>
                <button
                  className="h-fit text-white hover:bg-red-300 bg-red-500 cursor-pointer rounded-full p-1"
                  onClick={handleDeleteVideo}
                >
                  <MdOutlineDeleteOutline className="text-base" />
                </button>
              </div>
              <span className=" text-base text-default-gray text-wrap">
                {tutorial?.description
                  ? tutorial?.description?.slice(0, 35)
                  : "Sin descripción"}
                {(tutorial?.description?.length ?? 0) > 36 ? "..." : ""}.
              </span>
              <div className="flex flex-row gap-x-1 items-center">
                <IoMdPlay className="text-dark-green w-[20px]" />
                <span className="font-bold">
                  {tutorial.minutes}:{tutorial.seconds}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TutorialCard;
